import React, { memo } from 'react';
import LoadingOverlay from 'components/LoadingOverlay';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';

const AppLoading: React.FC = () => {
  const { visible, loadingText } = useSelector(
    (state: RootState) => state.loading
  );

  return <LoadingOverlay visible={visible} loadingText={loadingText} />;
};

export default memo(AppLoading);
